@if (!shouldRenderVideo) {
<div class="fill overflow-hidden"
     [ngClass]="photoswipeClass"
     [class._hasImageZoom]="hasImageZoom"
     [class._hasVideoZoom]="hasVideoZoom">
    <shell></shell>
    <img [fill]="true"
         [ratio]="ratio || 1"
         [dfImage]="source.image || ''"
         [alt]="alt"
         draggable="false"
         [loaderParams]="options"
         [photoswipe]="photoswipeImage || ''"
         [photoswipeUid]="photoswipeUid || ''"
         [photoswipeHtml]="videoIframeHtml || ''"
         [photoswipeThumbnail]="photoswipeImage || ''"
         [photoswipeOptions]="photoswipeOption || {}">
</div>
}
@if (shouldRenderVideo) {
<shell></shell>
@switch (provider || source.videoProvider) {
@case (EVideoProviders.youtube) {
<youtube-player class="z-2"
                [video-url]="source.video || ''"
                [background]="autoplay"
                [autoplay-in-viewport]="autoplay"
                [loop]="autoplay">

</youtube-player>}
@default {
<vimeo-player class="z-2"
              [video-url]="source.video || ''"
              [background]="autoplay"
              [autoplay-in-viewport]="autoplay"
              [loop]="autoplay">
</vimeo-player>
}}
}
